"use strict";
/**
 * Date formatting utilities — all dates displayed in SAST (GMT+2)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = formatDate;
exports.formatDateTime = formatDateTime;
exports.formatTime = formatTime;
var TIMEZONE = "Africa/Johannesburg";
/**
 * Format a date string or Date as a localized date (e.g., "8 Apr 2026")
 */
function formatDate(date) {
    if (!date)
        return "-";
    return new Date(date).toLocaleDateString("en-ZA", {
        timeZone: TIMEZONE,
        year: "numeric",
        month: "short",
        day: "numeric",
    });
}
/**
 * Format a date string or Date as a localized date+time (e.g., "8 Apr 2026, 14:30:00")
 */
function formatDateTime(date) {
    if (!date)
        return "-";
    return new Date(date).toLocaleString("en-ZA", {
        timeZone: TIMEZONE,
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
}
/**
 * Format a date string or Date as just time (e.g., "14:30:00")
 */
function formatTime(date) {
    if (!date)
        return "-";
    return new Date(date).toLocaleTimeString("en-ZA", {
        timeZone: TIMEZONE,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
}
